const mainContent = document.querySelector('.main-container'); 
const slides = document.getElementsByClassName('slide'); 
let curNum = 0; 

console.log(slides.length)

console.log('Content-Width',mainContent.offsetWidth, 'Window-Width', window.innerWidth)
console.log('mainContent-width', mainContent)

console.log('mainContent', mainContent.offsetWidth, 'Percentage', Math.round(78))

console.log('final', mainContent.offsetWidth * Math.round(79) / 100)

const finalPer = mainContent.offsetWidth * Math.round(79) / 100; 

mainContent.addEventListener('wheel', function(e) {

    e.preventDefault()
   

    if (e.deltaY > 0) {
        if (curNum <= - Math.round(finalPer)) {
          return;
        } else {
          curNum -= 245;
        }
      }
    
      if (e.deltaY < 0) {
        if (curNum >= 0) {
          return;
        } else {
          curNum += 245;
        }
      }

      console.log(curNum)

    mainContent.style.transform = `translateX(${curNum}px)`
    // mainContent.style.transition = 'all 0.5s ease'
})
// let num = 0;
// window.addEventListener('keydown', function(e) {
//   console.log(e.key)
  

//   if(e.key === 'ArrowRight') {
//     if (curNum <= - Math.round(finalPer)) {
//       return;
//     } else {
//       curNum -= 150;
//     }
//   }

//   if (e.key === 'ArrowLeft') {
//     if (curNum >= 0) {
//       return;
//     } else {
//       curNum += 150;
//     }
//   }
  
//   console.log(num)
//   mainContent.style.transform = `translateX(${curNum}px)`

// })


// 'ArrowLeft'